import { ENTER_FLOW_FIRST_STEP } from 'utils/cta/CTA';

export type ReferralUnavailableSubscriberStatus =
  | 'PREMIUM'
  | 'LITE'
  | 'FREEMIUM'
  | undefined;

interface ReferralUnavailableCta {
  href: string;
  linkText: string;
  shouldPreselectPremium: boolean;
}

const UPGRADE_TO_PREMIUM_LINK = '/account/subscriptions/upgrade';

export function getReferralUnavailableCta(
  subscriberStatus: ReferralUnavailableSubscriberStatus,
): ReferralUnavailableCta {
  if (subscriberStatus === 'LITE' || subscriberStatus === 'FREEMIUM') {
    return {
      href: UPGRADE_TO_PREMIUM_LINK,
      linkText: 'Upgrade to Premium',
      shouldPreselectPremium: false,
    };
  }

  return {
    href: ENTER_FLOW_FIRST_STEP,
    linkText: 'Get Premium',
    shouldPreselectPremium: true,
  };
}
